import _ from 'lodash';
import axios from 'axios';
import store from '@/store';
import { logger } from '../util/logger';
import logout from '@/util/logout';

// 创建axios实例
const fetch = axios.create({
	baseURL: '', // api的base_url
	timeout: 60000, // 請求超過時間
});

// request 攔截器
fetch.interceptors.request.use((config) => {
	const localConfig = config;
	localConfig.requestStartTime = Date.now();
	if (window.sessionStorage.getItem('token')) {
		localConfig.headers.Authorization = `Bearer ${window.sessionStorage.getItem('token')}`;
	}
	return config;
}, (error) => {
	Promise.reject(error);
});

// respone 攔截器
fetch.interceptors.response.use(
	(response) => {
		const res = response.data;
		if(response.headers.authorization){
			store.dispatch('setToken', response.headers.authorization);
			window.sessionStorage.setItem('token', response.headers.authorization);
		}

		if (res.status.toString().startsWith(9)) {
			const title = `API status ${res.status} error. `;
			const message = `${response.request.responseURL}<br>${res.result.message}`;
			logger('error', title + message);
		} else if (res.status.toString().startsWith(8)) {
			// 處理認證相關的8002錯誤
			if (res.status === 8002) {
				logout();
				return Promise.reject('unauthorized');
			}
		} else if (res.status !== 1) {
			const title = `API status ${res.status} error. `;
			const message = `${response.request.responseURL}<br>${res.result.message}`;
			logger('error', title + message);
			return Promise.reject('error');
		}
		return response.data;
	},
	(error) => {
		try {
			const title = 'API http error. ';
			const message = `${error.response.data.status}:${error.response.data.result}`;
			if (error.response.status === 401) {
				logger('error', title + message);
				logout();
			} else {
				logger('error', title + message);
			}
		} catch (e) {
			logger('error', 'API Network error. Please check your network connection');
		}
		return Promise.reject(error);
	},
);

fetch.cars_post = async function(url, req_params){
	return await fetch({method: 'post', url, data: {req_params}});
}

export default fetch;
